import { render } from "./eventCreate.vue?vue&type=template&id=68a6d0a2"
import script from "./eventCreate.vue?vue&type=script&lang=js"
export * from "./eventCreate.vue?vue&type=script&lang=js"

import "./eventCreate.vue?vue&type=style&index=0&id=68a6d0a2&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__